import Reflux from "reflux";

const exported = {
    NewFeedback: Reflux.createAction("NewFeedback") as RefluxAction<[string, string, string, string, number, any]>,
    DismissFeedback: Reflux.createAction("DismissFeedback") as RefluxAction<[string]>,
    DismissAll: Reflux.createAction("DismissAll") as RefluxAction<[]>
};

export default exported;

export const { NewFeedback, DismissFeedback, DismissAll } = exported;
